import Image from 'next/image';
import cn from 'classnames';
import { AiOutlineEye } from 'react-icons/ai';
import { IoMdHourglass } from 'react-icons/io';
import Link from 'next/link';
import { getImgUrl } from '@utils/functions/getImgUrl';
import Tag from './article-card/Tag';
import AuthorDetails from './article-card/AuthorDetails';
import ViewsAndReadTime from './article-card/ViewsAndReadTime';
import { PrimaryBadge } from 'stories/Badge.stories';

const BytesCard = ({
  type,
  topFeatured,
  tutorialCard,
  articleCard,
  href,
  data = {},
  titleOnly = false,
}) => {
  const {
    heroImage,
    cardTitle,
    description,
    title,
    tags,
    slug,
    views,
    body,
    bodyPreview,
    cardImage = null,
    author = {},
  } = data?.attributes || data || {};

  const link = articleCard
    ? `/bytes/articles/${encodeURIComponent(slug)}`
    : `/bytes/tutorials/${encodeURIComponent(slug)}`;

  return (
    <div>
      <Link href={link} as={link} passHref>
        <a
          className={cn(
            { 'gap-4 md:flex-row': topFeatured },
            'flex h-full cursor-pointer flex-col items-stretch justify-between overflow-hidden rounded-md border border-gray-1/5 font-satoshi-medium  shadow-xl shadow-black/5'
          )}
        >
          {topFeatured ? (
            <div className="relative flex items-center overflow-hidden md:w-9/12">
              <Image
                src={heroImage?.data ? getImgUrl(heroImage) : '/assets/bytes/broken-img.jpg'}
                className="h-48 w-full object-contain lg:h-64"
                height={295}
                width={450}
                objectFit="contain"
                alt="top-card"
              />
              <p className="absolute bottom-8 left-0 bg-red p-2 px-9 text-sm tracking-normal text-white">
                TOP READ
              </p>
            </div>
          ) : (
            <>
              {tutorialCard ? (
                <div className="cursor-pointer text-white">
                  <p className="flex items-center bg-bytes-black-3 p-5 px-5 text-xl font-extrabold">
                    <Image
                      src={
                        heroImage?.data
                          ? getImgUrl(cardImage ?? heroImage)
                          : '/assets/bytes/broken-img.jpg'
                      }
                      height={50}
                      width={50}
                      objectFit="contain"
                      alt="card-icon"
                      className="h-12 w-12 rounded-md object-contain"
                    />
                    <span className="ml-6 text-left font-satoshi-medium line-clamp-2">
                      {cardTitle ?? 'Tutorial'}
                    </span>
                  </p>
                </div>
              ) : (
                <div className="cursor-pointer">
                  <Image
                    src={getImgUrl(heroImage)}
                    height={300}
                    width={500}
                    objectFit="contain"
                    alt={heroImage?.data?.attributes?.name ?? 'img'}
                  />
                </div>
              )}
            </>
          )}
          <section
            className={cn(
              { '!pt-0': articleCard },
              'flex h-fit w-full flex-col space-y-4 px-5 py-6'
            )}
          >
            <div className={cn(`flex select-none gap-3 child:bg-[#FEE9E6]`)}>
              {(tags?.data ?? tags)?.slice(0, 2).map((item) => (
                <PrimaryBadge label={item?.attributes?.name ?? item?.name} key={item.id} />
              ))}
            </div>
            <p
              className={cn(
                { 'h-[3.3rem] !text-xl': topFeatured },
                { 'h-12 lg:h-14': articleCard },
                { '!line-clamp-1': tutorialCard },
                'texte  cursor-pointer text-left font-satoshi-medium font-satoshi-bold text-sm font-bold  leading-6 tracking-wide line-clamp-2 md:w-auto lg:text-lg'
              )}
            >
              {title}
            </p>
            {/* </Link> */}
            {articleCard && <AuthorDetails {...author?.data?.attributes} />}
            {!tutorialCard && !titleOnly && (
              <p className="text-left font-satoshi-regular text-xs tracking-normal text-[#919191] line-clamp-5 md:text-sm">
                {description ?? bodyPreview}
              </p>
            )}
            <ViewsAndReadTime
              tutorialCard={tutorialCard ?? topFeatured}
              text={body ?? description}
              views={views}
            />
          </section>{' '}
        </a>
      </Link>
    </div>
  );
};
export default BytesCard;
